import { AlertController } from 'ionic-angular';
import { App } from "ionic-angular"
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
 
import { Observable } from 'rxjs';
import { _throw } from 'rxjs/observable/throw';
import { catchError, mergeMap } from 'rxjs/operators';
import {LoginPage} from '../../pages/login/login' ;

@Injectable()
export class InterceptorProvider implements HttpInterceptor {
 
    constructor(private storage: Storage, private alertCtrl: AlertController,private app:App) { }
 
    // Intercepts all HTTP requests!
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
        let promise = this.storage.get('token');
        
        return Observable.fromPromise(promise)
            .mergeMap(token => {

                let clonedReq = this.addToken(request, token);
                return next.handle(clonedReq).pipe(

                    catchError(error => {
                        // Perhaps display an error for specific status codes here already?
                        let msg = error.message;
 
                        let alert = this.alertCtrl.create({
                            title: 'Warning',
                            message: "We are unable to resolve your problem please try again!",
                            buttons: [{text: 'Ok',
                                      handler: data => {
                                        localStorage.clear();
                                        this.app.getRootNav().setRoot(LoginPage)
                                      }}],

                        });
                        alert.present();
 
                        // Pass the error to the caller of the function
                        return _throw(error);
                    })
                );
            });
    }
 
    // Adds the token to your headers if it exists
    private addToken(request: HttpRequest<any>, token: any) {

        if (token) {
            
            
           
            let clone: HttpRequest<any>;
            clone = request.clone({
                setHeaders: {
                    Accept: `application/json`,
                    
                    Authorization: `${token?token:localStorage.getItem("token")?localStorage.getItem("token") :"" }`
                }
            });
            return clone;
        }
 
        return request;
    }
}


// WEBPACK FOOTER //
// ./src/providers/interceptor/interceptor.ts